import React, { ReactComponentElement } from "react";
import { IntoIcon } from "../../assets";
import { Link } from "../Link";
import "./Button.scss";

export type ButtonProps = {
  cx?: string;
  click?: React.MouseEventHandler;
  disabled?: boolean;
  to?: string;
  size?: "normal" | "small" | "large";
  inner?: boolean;
  outline?: boolean;
  isNext?: boolean;
  icon?: ReactComponentElement<any>;
  routerLink?: any;
};

export const Button: React.FC<ButtonProps> = ({
  cx = "",
  children,
  click = undefined,
  disabled,
  to,
  size = "normal",
  outline = false,
  isNext = false,
  icon,
  routerLink,
  ...props
}) => {
  const cn = `Button ${size} ${outline ? "outline" : ""} ${
    isNext ? "isNext" : ""
  } ${cx}`.trim();

  const content = (
    <>
      {icon}
      <div className={"text"}>{children}</div>
      {isNext && <IntoIcon />}
    </>
  );

  if (!!to && !!routerLink) {
    return (
      <Link cx={cn} to={to} routerLink={routerLink} {...props}>
        {content}
      </Link>
    );
  } else {
    return (
      <button className={cn} onClick={click} disabled={disabled} {...props}>
        {content}
      </button>
    );
  }
};
